import { Box, Stack } from '@mui/material';

import PageHeader from 'domains/core/components/PageHeader';

export const pageLayoutChildrenBoxSx = {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
} as const;

export type Props = {
    header: React.ReactNode;
    headerIcon: React.ReactNode;
    headerAction?: React.ReactNode;
    headerOthers?: React.ReactNode;
    children?: React.ReactNode;
};

const PageLayout = ({ header, headerIcon, headerAction, headerOthers, children }: Props) => (
    <Stack width="100%" height="100%" minHeight={0} mt={8} rowGap={8}>
        <Stack direction="row" justifyContent="space-between" width="100%">
            <PageHeader icon={headerIcon} header={header} headerOthers={headerOthers} />
            <Stack>{headerAction}</Stack>
        </Stack>
        <Box sx={pageLayoutChildrenBoxSx}>{children}</Box>
    </Stack>
);

export default PageLayout;
